import { filter, includes, map } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";
import { useFacetsFromQueries } from "./useFacetsFromQueries";

export function useWorkspaceFacets() {
  const focuses = useCurrentProject()?.focuses || [];
  const workspace = useCurrentWorkspace();
  const workspaceFocuses = map(workspace?.focuses, "id");
  return useFacetsFromQueries(
    filter(focuses, (query) => includes(workspaceFocuses, query.id))
  );
}
